import { render, staticRenderFns } from "./u-radio.vue?vue&type=template&id=51d7da7a&scoped=true&"
import script from "./u-radio.vue?vue&type=script&lang=js&"
export * from "./u-radio.vue?vue&type=script&lang=js&"
import style0 from "./u-radio.vue?vue&type=style&index=0&id=51d7da7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d7da7a",
  null
  
)

export default component.exports